export default __webpack_public_path__ + "media/apps/Configurator/images/Premium-Options-Logo-74052b4b5515e716849da2e2b371a632.png";